import { useParams } from 'react-router-dom'

import { Alert } from '@vtex/shoreline'
import { t } from 'i18next'

import { useAppInfo } from '~/hooks/useAppInfo'
import useQueryParams from '~/hooks/useQuery'
import WalletHeader from '~/modules/retailMedia/components/WalltetHeader'

import FormRecharge from './components/Form'

const WalletRecharge = () => {
  const { hasRecharge } = useAppInfo()

  const { id: walletId } = useParams()
  const publisherId = useQueryParams().get('rmid')

  return (
    <>
      <WalletHeader
        title={t('rm:wallet.recharge')}
        labelBreadcrumb={t('rm:wallet.backTo')}
        backTo={`/retail-media/wallet/${walletId}/movimentations?rmid=${publisherId}`}
        showActions={false}
      />

      {hasRecharge && publisherId && <FormRecharge />}

      {!hasRecharge && (
        <Alert variant="critical">
          {t('rm:wallet.recharge.automatic.notAvailable')}
        </Alert>
      )}

      {!publisherId && (
        <Alert variant="critical">{t('rm:alerts.publisher.idNotFound')}</Alert>
      )}
    </>
  )
}

export default WalletRecharge
